(function($) {

  var loading;

  $('#WhoIsForm').on('submit', function(e) {
    e.preventDefault();

    var $this = $(this);

    if( loading ) { console.log('still loading ...'); return; }

    var domain = $this.find('#domain').val();
    var action = $this.find('#action').val();

    if( !(domain && action) ) { console.log('no input ...'); return; }

    var currentUrl = window.location.href.split('?')[0];
    var ajaxurl = currentUrl + '?action=' + action + '&domain=' + domain; 

    // ajax-call

    try {
      loading = true;
      jQuery.get(ajaxurl, function (data) {
        try {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newResultsWrapper = htmlDoc.querySelector( '.who-is-results-wrapper' );
          const oldResultsWrapper = document.querySelector( '.who-is-results-wrapper' );
          oldResultsWrapper.innerHTML = newResultsWrapper.innerHTML;
        } catch (e) {
          console.log(e);
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        })
        .always(function () {
          loading = false;
        });
    } catch (e) {
      loading = false;
    }

  });

})(jQuery);